import styled from 'styled-components';
import MUIButton from '@mui/material/Button';
import MUIIconButton from '@mui/material/IconButton';
import MUISnackbar from '@mui/material/Snackbar';
import MUITypography from '@mui/material/Typography';
import { Colors } from '../../theme';
const SNACKBAR_WIDTH = '320px';
export const Snackbar = styled(MUISnackbar) `
  @media (width <= 1024px) {
    bottom: 16px;
  }

  @media (width >= 1024px) {
    top: 90px;
  }

  user-select: none;

  & div[role='alert'] {
    box-sizing: border-box;
    width: ${SNACKBAR_WIDTH};
    padding: 12px 16px;
    background-color: ${Colors.black80};
    box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 3px 1px -2px rgb(0 0 0 / 12%),
      0 2px 2px rgb(0 0 0 / 14%);
  }

  & .MuiSnackbarContent-message {
    padding: 0;

    p {
      font-size: 16px;
    }
  }

  & .MuiSnackbarContent-action {
    margin-right: 0;
  }
`;
export const SessionExtendedSnackbarContentMessage = styled('div') `
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const Button = styled(MUIButton) `
  padding: 0;
  margin-top: 2px;
  color: ${Colors.blue40};

  svg {
    font-size: 24px;
  }
`;
export const Typography = styled(MUITypography) `
  margin-left: 4px;
`;
export const IconButton = styled(MUIIconButton) `
  padding: 0;

  svg {
    font-size: 24px;
  }
`;
//# sourceMappingURL=styles.js.map